/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { AaiSchema } from '../../asyncapi/models/AaiSchema';
import { SimplifiedPropertyType } from '../models/SimplifiedPropertyType';
import { ModelUtils } from '../util/ModelUtils';
import { SimplifiedTypeUtil } from '../util/SimplifiedTypeUtil';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { IPropertySchema } from '../../core/models/common/IPropertySchema';
import { Schema } from '../../core/models/common/Schema';
import { NewSchemaPropertyCommand } from './NewSchemaPropertyCommand';
import { NodePath } from '../../core/models/NodePath';

/**
 * A command used to create a new schema property for AsyncAPI Schema
 * @author laurent.broudoux@gmail.com
 * @extends NewSchemaPropertyCommand
 * @class
 */
export class NewSchemaPropertyCommand_Aai20 extends NewSchemaPropertyCommand {
    public constructor(schema? : any, propertyName? : any, description? : any, newType? : any) {
        if(((schema != null && schema instanceof <any>Schema) || schema === null) && ((typeof propertyName === 'string') || propertyName === null) && ((typeof description === 'string') || description === null) && ((newType != null && newType instanceof <any>SimplifiedPropertyType) || newType === null)) {
            let __args = arguments;
            super(schema, propertyName, description, newType);
        } else if(schema === undefined && propertyName === undefined && description === undefined && newType === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewSchemaPropertyCommand_Aai20] Executing.");
        this._created = false;
        let schema : AaiSchema = <AaiSchema>this._schemaPath.resolve(document);
        if(this.isNullOrUndefined(schema)) {
            LoggerCompat.info("[NewSchemaPropertyCommand_Aai20] Schema is null.");
            return;
        }
        if(ModelUtils.isDefined(schema.getProperty(this._propertyName))) {
            LoggerCompat.info("[NewSchemaPropertyCommand_Aai20] Property already exists.");
            return;
        }
        let property : AaiSchema = <AaiSchema>schema.createPropertySchema(this._propertyName);
        if(ModelUtils.isDefined(this._description)) {
            property.description = this._description;
        }
        if(ModelUtils.isDefined(this._newType)) {
            this._setPropertyType(<IPropertySchema><any>property);
        }
        schema.addProperty(this._propertyName, property);
        LoggerCompat.info("[NewSchemaPropertyCommand_Aai20] Property [%s] created successfully.", this._propertyName);
        this._created = true;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewSchemaPropertyCommand_Aai20] Reverting.");
        if(!this._created) {
            return;
        }
        let schema : AaiSchema = <AaiSchema>this._schemaPath.resolve(document);
        if(this.isNullOrUndefined(schema)) {
            return;
        }
        if(this.isNullOrUndefined(schema.getProperty(this._propertyName))) {
            return;
        }
        schema.removeProperty(this._propertyName);
        if(ModelUtils.isDefined(this._newType) && this._newType.required === true) {
            let required : Array<string> = schema.required;
            /* remove */required.splice(required.indexOf(this._propertyName), 1)[0];
        }
    }

    /**
     * Sets the property type.
     * @param {*} prop
     */
    _setPropertyType(prop : IPropertySchema) {
        SimplifiedTypeUtil.setSimplifiedType(<AaiSchema><any>prop, this._newType);
        if(ModelUtils.isDefined(this._newType) && this._newType.required === true) {
            let parent : AaiSchema = <AaiSchema>(<Node><any>prop).parent();
            let required : Array<string> = parent.required;
            if(this.isNullOrUndefined(required)) {
                required = <any>([]);
                NodeCompat.setProperty(parent, Constants.PROP_REQUIRED, required);
                this._nullRequired = true;
            }
            /* add */(required.push(prop.getPropertyName())>0);
        }
    }
}
NewSchemaPropertyCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.NewSchemaPropertyCommand_Aai20";
NewSchemaPropertyCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




